import { useState, useEffect } from 'react';
import { api } from '../api';

const BADGE = {
  validada:        { background: '#e8f5e9', color: '#2e7d32', label: '✅ Validada' },
  validada_manual: { background: '#e0f7fa', color: '#0077b6', label: '🔵 Validada Manual' },
  no_validada:     { background: '#fce4ec', color: '#c62828', label: '❌ No validada' },
  pendiente:       { background: '#fff8e1', color: '#f57f17', label: '⏳ Pendiente' },
};

const POR_PAGINA = 25;

export default function Ordenes() {
  const [termino, setTermino]           = useState('');
  const [ordenes, setOrdenes]           = useState([]);
  const [cargando, setCargando]         = useState(true);
  const [validando, setValidando]       = useState(null);
  const [pagina, setPagina]             = useState(1);
  const [inputFactura, setInputFactura] = useState(null);
  const [modalOrden, setModalOrden]     = useState(null);

  useEffect(() => {
    validarPendientes().then(() => buscar());
  }, []);

  const buscar = async (q = '') => {
    setCargando(true);
    setPagina(1);
    try {
      const url = q ? `/ordenes/buscar?q=${encodeURIComponent(q)}` : '/ordenes/buscar';
      const data = await api.get(url);
      setOrdenes(data.ordenes || []);
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  };

  const validarPendientes = async () => {
    try { await api.post('/ordenes/validar', {}); }
    catch (e) { console.log('Error validando:', e); }
  };

  const abrirInputFactura = (id) => {
    setInputFactura({ id, valor: '', cargando: false, error: null });
  };

  const cerrarInputFactura = () => setInputFactura(null);

  const confirmarFacturaManual = async () => {
    if (!inputFactura.valor.trim()) {
      setInputFactura(prev => ({ ...prev, error: 'Ingresa el número de factura' }));
      return;
    }
    setInputFactura(prev => ({ ...prev, cargando: true, error: null }));
    try {
      const data = await api.post(
        `/ordenes/validar-manual/${inputFactura.id}`,
        { factura: inputFactura.valor.trim() }
      );
      if (data.error) {
        setInputFactura(prev => ({ ...prev, cargando: false, error: data.error }));
      } else {
        setInputFactura(null);
        buscar(termino);
      }
    } catch (e) {
      setInputFactura(prev => ({ ...prev, cargando: false, error: 'Error de conexión' }));
    }
  };

  // ── Paginación ──
  const totalPaginas  = Math.ceil(ordenes.length / POR_PAGINA);
  const inicio        = (pagina - 1) * POR_PAGINA;
  const ordenesPagina = ordenes.slice(inicio, inicio + POR_PAGINA);

  const irPagina = (p) => {
    if (p < 1 || p > totalPaginas) return;
    setPagina(p);
    setInputFactura(null);
  };

  const paginasVisibles = () => {
    let desde = Math.max(1, pagina - 2);
    let hasta  = Math.min(totalPaginas, desde + 4);
    desde = Math.max(1, hasta - 4);
    const rango = [];
    for (let i = desde; i <= hasta; i++) rango.push(i);
    return rango;
  };

  const calcularRecorrido = (kmAnterior, kmActual) => {
    if (!kmAnterior || !kmActual) return null;
    const anterior = parseInt(kmAnterior.replace(/[^0-9]/g, ''));
    const actual   = parseInt(kmActual.replace(/[^0-9]/g, ''));
    if (isNaN(anterior) || isNaN(actual)) return null;
    const recorrido = actual - anterior;
    return recorrido > 0 ? recorrido : null;
  };

  const generarHTML = (o) => {
    const recorrido = calcularRecorrido(o.km_anterior, o.km_actual);
    return `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:14px; width:148mm; font-size:12px; }
      .header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:10px; }
      .logo { font-size:18px; font-weight:bold; color:#1a1a2e; }
      .logo span { color:#e63946; }
      .orden-box { border:2px solid #1a1a2e; padding:6px 12px; text-align:center; border-radius:4px; }
      .orden-num { font-size:20px; font-weight:bold; color:#1a1a2e; }
      .datos { border:1px solid #ddd; border-radius:4px; padding:8px; margin-bottom:10px; }
      .datos table { width:100%; border-collapse:collapse; }
      .datos td { padding:3px 4px; font-size:11px; }
      .label { font-weight:bold; color:#555; width:30%; }
      .nota { background:#fff3cd; border:1px solid #ffc107; border-radius:4px; padding:6px 10px; margin-bottom:10px; font-size:11px; color:#856404; }
      .nota-km { background:#f0f4ff; border:1px solid #1a1a2e; border-radius:4px; padding:6px 10px; margin-bottom:10px; font-size:11px; color:#1a1a2e; }
      .firmas { display:flex; justify-content:space-between; margin-top:24px; }
      .firma { text-align:center; width:45%; }
      .firma-linea { border-top:1px solid #000; margin-bottom:4px; }
      .firma-txt { font-size:10px; color:#555; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <div class="logo">🔧 TALLER <span>ZOLER</span></div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
        <div class="orden-box">
          <div style="font-size:9px;font-weight:bold;color:#555;">ORDEN DE PEDIDO</div>
          <div class="orden-num">${o.numero_orden}</div>
        </div>
      </div>
      <div class="nota">🖨️ REIMPRESIÓN — Orden generada el ${o.fecha}</div>
      <div class="datos">
        <table>
          <tr>
            <td class="label">Cliente:</td><td>${o.cliente}</td>
            <td class="label">Placa:</td><td><strong style="color:#1a1a2e;">${o.placa}</strong></td>
          </tr>
          ${o.marca_vehiculo ? `
          <tr>
            <td class="label">Marca:</td><td>${o.marca_vehiculo}</td>
            <td class="label">Modelo:</td><td>${o.modelo_vehiculo || '—'}</td>
          </tr>
          <tr>
            <td class="label">Año:</td><td>${o.anio_vehiculo || '—'}</td>
            <td class="label">Teléfono:</td><td>${o.telefono || '—'}</td>
          </tr>` : `
          <tr>
            <td class="label">Teléfono:</td><td colspan="3">${o.telefono || '—'}</td>
          </tr>`}
          <tr>
            <td class="label">Técnico:</td><td><strong>${o.tecnico || '—'}</strong></td>
            <td class="label">Fecha:</td><td>${o.fecha}</td>
          </tr>
          ${o.km_actual ? `
          <tr>
            <td class="label">KM Actual:</td><td>${o.km_actual}</td>
            <td class="label">Tipo:</td><td>${o.tipo_vehiculo || '—'}</td>
          </tr>` : o.tipo_vehiculo ? `
          <tr>
            <td class="label">Tipo:</td><td colspan="3">${o.tipo_vehiculo}</td>
          </tr>` : ''}
        </table>
      </div>
      ${recorrido ? `
      <div class="nota-km">
        📍 Kilómetros recorridos desde el último cambio: <strong>${recorrido.toLocaleString()} km</strong>
        (Kilometraje anterior: ${o.km_anterior})
      </div>` : ''}
      <table style="width:100%;border-collapse:collapse;margin-bottom:12px;">
        <thead>
          <tr style="background:#1a1a2e;color:#fff;">
            <th style="padding:6px 8px;font-size:11px;text-align:center;width:12%;">CANT.</th>
            <th style="padding:6px 8px;font-size:11px;text-align:left;">CÓDIGO</th>
            <th style="padding:6px 8px;font-size:11px;text-align:left;">DESCRIPCIÓN</th>
            <th style="padding:6px 8px;font-size:11px;text-align:center;width:12%;">UNID.</th>
          </tr>
        </thead>
        <tbody>
          ${o.items && o.items.length > 0
            ? o.items.map(item => `
              <tr>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;text-align:center;">${parseFloat(item.cantidad).toFixed(2)}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;">${item.codigo}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;">${item.descripcion}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;text-align:center;">${item.unidad}</td>
              </tr>`).join('')
            : '<tr><td colspan="4" style="text-align:center;padding:12px;color:#aaa;border:1px solid #ccc;">Sin ítems registrados</td></tr>'
          }
        </tbody>
      </table>
      <div class="firmas">
        <div class="firma"><div class="firma-linea"></div><div class="firma-txt">FIRMA AUTORIZADA</div></div>
        <div class="firma"><div class="firma-linea"></div><div class="firma-txt">TÉCNICO RESPONSABLE${o.tecnico ? `: ${o.tecnico}` : ''}</div></div>
      </div>
    </body></html>`;
  };

  const reimprimir = (orden) => {
    const ventana = window.open('', '_blank', 'width=800,height=600');
    if (!ventana) { alert('Permite las ventanas emergentes para este sitio'); return; }
    ventana.document.write(generarHTML(orden));
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  // ── Modal de vista previa ──
  const ModalOrden = ({ orden, onCerrar }) => {
    if (!orden) return null;
    const recorrido = calcularRecorrido(orden.km_anterior, orden.km_actual);
    const badge = BADGE[orden.validacion] || BADGE.pendiente;

    return (
      <div style={s.modalOverlay} onClick={onCerrar}>
        <div style={s.modalContainer} onClick={e => e.stopPropagation()}>

          {/* Header del modal */}
          <div style={s.modalHeader}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={s.modalTitulo}>📋 Orden #{orden.numero_orden}</span>
              <span style={{ ...s.badge, background: badge.background, color: badge.color }}>
                {badge.label}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={s.modalBotonImprimir} onClick={() => reimprimir(orden)} title="Imprimir">
                🖨️ Imprimir
              </button>
              <button style={s.modalBotonCerrar} onClick={onCerrar}>✕</button>
            </div>
          </div>

          {/* Contenido */}
          <div style={s.modalBody}>

            {/* Datos del vehículo y cliente */}
            <div style={s.modalSeccion}>
              <div style={s.modalGrid}>
                <div style={s.modalCampo}>
                  <span style={s.modalLabel}>Cliente</span>
                  <span style={s.modalValor}>{orden.cliente}</span>
                </div>
                <div style={s.modalCampo}>
                  <span style={s.modalLabel}>Placa</span>
                  <span style={{ ...s.modalValor, color: '#4cc9f0', fontWeight: 'bold', fontSize: 16 }}>{orden.placa}</span>
                </div>
                {orden.marca_vehiculo && <>
                  <div style={s.modalCampo}>
                    <span style={s.modalLabel}>Marca</span>
                    <span style={s.modalValor}>{orden.marca_vehiculo}</span>
                  </div>
                  <div style={s.modalCampo}>
                    <span style={s.modalLabel}>Modelo</span>
                    <span style={s.modalValor}>{orden.modelo_vehiculo || '—'}</span>
                  </div>
                  <div style={s.modalCampo}>
                    <span style={s.modalLabel}>Año</span>
                    <span style={s.modalValor}>{orden.anio_vehiculo || '—'}</span>
                  </div>
                </>}
                <div style={s.modalCampo}>
                  <span style={s.modalLabel}>Teléfono</span>
                  <span style={s.modalValor}>{orden.telefono || '—'}</span>
                </div>
                <div style={s.modalCampo}>
                  <span style={s.modalLabel}>Técnico</span>
                  <span style={s.modalValor}>{orden.tecnico || '—'}</span>
                </div>
                <div style={s.modalCampo}>
                  <span style={s.modalLabel}>Fecha</span>
                  <span style={s.modalValor}>{orden.fecha}</span>
                </div>
                {orden.km_actual && (
                  <div style={s.modalCampo}>
                    <span style={s.modalLabel}>KM Actual</span>
                    <span style={s.modalValor}>{orden.km_actual}</span>
                  </div>
                )}
                {orden.tipo_vehiculo && (
                  <div style={s.modalCampo}>
                    <span style={s.modalLabel}>Tipo</span>
                    <span style={s.modalValor}>{orden.tipo_vehiculo}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Alerta km recorridos */}
            {recorrido && (
              <div style={s.modalAlertaKm}>
                📍 Kilómetros recorridos desde el último cambio: <strong>{recorrido.toLocaleString()} km</strong>
                <span style={{ color: '#888', marginLeft: 8 }}>(anterior: {orden.km_anterior})</span>
              </div>
            )}

            {/* Tabla de ítems */}
            <div style={s.modalSeccionTitulo}>Ítems de la orden</div>
            <div style={s.modalTabla}>
              <div style={s.modalTablaHeader}>
                <span style={{ ...s.modalTablaCol, flex: '0 0 60px', textAlign: 'center' }}>CANT.</span>
                <span style={{ ...s.modalTablaCol, flex: '0 0 120px' }}>CÓDIGO</span>
                <span style={{ ...s.modalTablaCol, flex: 1 }}>DESCRIPCIÓN</span>
                <span style={{ ...s.modalTablaCol, flex: '0 0 60px', textAlign: 'center' }}>UNID.</span>
              </div>
              {orden.items && orden.items.length > 0
                ? orden.items.map((item, i) => (
                  <div key={i} style={{ ...s.modalTablaRow, background: i % 2 === 0 ? '#1a1a2e' : '#161625' }}>
                    <span style={{ ...s.modalTablaCol, flex: '0 0 60px', textAlign: 'center', color: '#fff' }}>
                      {parseFloat(item.cantidad).toFixed(2)}
                    </span>
                    <span style={{ ...s.modalTablaCol, flex: '0 0 120px', color: '#4cc9f0', fontFamily: 'monospace' }}>
                      {item.codigo}
                    </span>
                    <span style={{ ...s.modalTablaCol, flex: 1, color: '#ddd' }}>
                      {item.descripcion}
                    </span>
                    <span style={{ ...s.modalTablaCol, flex: '0 0 60px', textAlign: 'center', color: '#aaa' }}>
                      {item.unidad}
                    </span>
                  </div>
                ))
                : <div style={{ color: '#555', textAlign: 'center', padding: 24 }}>Sin ítems registrados</div>
              }
            </div>

            {/* Firmas */}
            <div style={s.modalFirmas}>
              <div style={s.modalFirma}>
                <div style={s.modalFirmaLinea} />
                <span style={s.modalFirmaTxt}>FIRMA AUTORIZADA</span>
              </div>
              <div style={s.modalFirma}>
                <div style={s.modalFirmaLinea} />
                <span style={s.modalFirmaTxt}>TÉCNICO{orden.tecnico ? `: ${orden.tecnico}` : ''}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Paginador = () => (
    <div style={s.paginacionRow}>
      <span style={s.totalInfo}>
        {ordenes.length} órdenes · mostrando {inicio + 1}–{Math.min(inicio + POR_PAGINA, ordenes.length)}
      </span>
      <div style={s.paginaBotones}>
        <button style={s.paginaBtn} onClick={() => irPagina(1)} disabled={pagina === 1}>«</button>
        <button style={s.paginaBtn} onClick={() => irPagina(pagina - 1)} disabled={pagina === 1}>‹</button>
        {paginasVisibles().map(p => (
          <button
            key={p}
            style={{ ...s.paginaBtn, ...(p === pagina ? s.paginaBtnActivo : {}) }}
            onClick={() => irPagina(p)}
          >
            {p}
          </button>
        ))}
        <button style={s.paginaBtn} onClick={() => irPagina(pagina + 1)} disabled={pagina === totalPaginas}>›</button>
        <button style={s.paginaBtn} onClick={() => irPagina(totalPaginas)} disabled={pagina === totalPaginas}>»</button>
      </div>
    </div>
  );

  return (
    <div>
      <ModalOrden orden={modalOrden} onCerrar={() => setModalOrden(null)} />
      <h2 style={s.titulo}>📋 Órdenes</h2>

      <div style={s.buscadorRow}>
        <input
          style={s.input}
          value={termino}
          onChange={e => setTermino(e.target.value)}
          placeholder="Buscar por número o placa..."
          onKeyDown={e => e.key === 'Enter' && buscar(termino)}
        />
        <button style={s.botonBuscar} onClick={() => buscar(termino)}>🔍 Buscar</button>
        {termino && (
          <button style={s.botonLimpiar} onClick={() => { setTermino(''); buscar(''); }}>✕</button>
        )}
      </div>

      {cargando ? (
        <p style={s.cargando}>Cargando órdenes...</p>
      ) : ordenes.length === 0 ? (
        <p style={s.vacio}>No se encontraron órdenes</p>
      ) : (
        <>
          <Paginador />

          <div style={s.tabla}>
            <div style={s.tablaHeader}>
              <span style={{...s.col, flex: 1}}>Orden</span>
              <span style={{...s.col, flex: 1}}>Placa</span>
              <span style={{...s.col, flex: 2}}>Cliente</span>
              <span style={{...s.col, flex: 1}}>Técnico</span>
              <span style={{...s.col, flex: 1}}>Tipo</span>
              <span style={{...s.col, flex: 1}}>Fecha</span>
              <span style={{...s.col, flex: 1}}>Estado</span>
              <span style={{...s.col, width: 120}}>Acción</span>
            </div>

            {ordenesPagina.map(o => {
              const badge = BADGE[o.validacion] || BADGE.pendiente;
              const mostrarInput = inputFactura?.id === o.id;

              return (
                <div key={o.numero_orden}>
                  {/* Fila principal */}
                  <div style={{
                    ...s.tablaRow,
                    ...(mostrarInput ? { background: '#1a2a3e', borderBottom: 'none' } : {})
                  }}>
                    <span style={{...s.col, flex: 1, color: '#4cc9f0', fontWeight: 'bold'}}>#{o.numero_orden}</span>
                    <span style={{...s.col, flex: 1, color: '#fff', fontWeight: '600'}}>{o.placa}</span>
                    <span style={{...s.col, flex: 2, color: '#ccc'}}>
                      {o.cliente}
                      {o.es_cliente_nuevo && <span style={s.badgeNuevo}>NUEVO</span>}
                    </span>
                    <span style={{...s.col, flex: 1, color: '#aaa'}}>{o.tecnico || '—'}</span>
                    <span style={{...s.col, flex: 1, color: '#aaa'}}>{o.tipo_vehiculo || '—'}</span>
                    <span style={{...s.col, flex: 1, color: '#aaa', fontSize: 12}}>{o.fecha}</span>
                    <span style={{...s.col, flex: 1}}>
                      <span style={{...s.badge, background: badge.background, color: badge.color}}>
                        {badge.label}
                      </span>
                    </span>
                    <span style={{...s.col, width: 120, gap: 6}}>
                      <button style={s.botonVer} onClick={() => setModalOrden(o)} title="Ver orden">
                        👁
                      </button>
                      <button style={s.botonImprimir} onClick={() => reimprimir(o)} title="Reimprimir">
                        🖨️
                      </button>
                      {o.validacion === 'no_validada' && !mostrarInput && (
                        <button
                          style={s.botonRevalidar}
                          onClick={() => abrirInputFactura(o.id)}
                          disabled={validando === o.id}
                          title="Vincular factura manualmente"
                        >
                          {validando === o.id ? '...' : '🔄'}
                        </button>
                      )}
                      {mostrarInput && (
                        <button style={s.botonCancelar} onClick={cerrarInputFactura} title="Cancelar">✕</button>
                      )}
                    </span>
                  </div>

                  {/* Input factura manual */}
                  {mostrarInput && (
                    <div style={s.inputFacturaRow}>
                      <div style={s.inputFacturaInner}>
                        <span style={s.inputFacturaLabel}>📄 Nº Factura Morpheus:</span>
                        <input
                          style={{
                            ...s.inputFactura,
                            ...(inputFactura.error ? { borderColor: '#e63946' } : {})
                          }}
                          value={inputFactura.valor}
                          onChange={e => setInputFactura(prev => ({
                            ...prev, valor: e.target.value.toUpperCase(), error: null
                          }))}
                          onKeyDown={e => e.key === 'Enter' && confirmarFacturaManual()}
                          placeholder="Ej: FAC-001234"
                          autoFocus
                          disabled={inputFactura.cargando}
                        />
                        <button
                          style={{
                            ...s.botonConfirmar,
                            ...(inputFactura.cargando ? { opacity: 0.6, cursor: 'default' } : {})
                          }}
                          onClick={confirmarFacturaManual}
                          disabled={inputFactura.cargando}
                        >
                          {inputFactura.cargando ? 'Verificando...' : '✅ Confirmar'}
                        </button>
                      </div>
                      {inputFactura.error && (
                        <div style={s.inputFacturaError}>⚠️ {inputFactura.error}</div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Paginador inferior */}
          {totalPaginas > 1 && (
            <div style={{ ...s.paginacionRow, marginTop: 16 }}>
              <span style={s.totalInfo}>Página {pagina} de {totalPaginas}</span>
              <div style={s.paginaBotones}>
                <button style={s.paginaBtn} onClick={() => irPagina(1)} disabled={pagina === 1}>«</button>
                <button style={s.paginaBtn} onClick={() => irPagina(pagina - 1)} disabled={pagina === 1}>‹</button>
                {paginasVisibles().map(p => (
                  <button
                    key={p}
                    style={{ ...s.paginaBtn, ...(p === pagina ? s.paginaBtnActivo : {}) }}
                    onClick={() => irPagina(p)}
                  >
                    {p}
                  </button>
                ))}
                <button style={s.paginaBtn} onClick={() => irPagina(pagina + 1)} disabled={pagina === totalPaginas}>›</button>
                <button style={s.paginaBtn} onClick={() => irPagina(totalPaginas)} disabled={pagina === totalPaginas}>»</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const s = {
  titulo: { color: '#fff', marginBottom: 24 },
  buscadorRow: { display: 'flex', gap: 8, marginBottom: 16 },
  input: { flex: 1, background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 8, padding: '10px 16px', color: '#fff', fontSize: 14 },
  botonBuscar: { background: '#1a1a2e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold' },
  botonLimpiar: { background: '#2d2d44', border: 'none', borderRadius: 8, color: '#fff', padding: '10px 14px', cursor: 'pointer' },
  cargando: { color: '#aaa' },
  vacio: { color: '#555', textAlign: 'center', marginTop: 60 },
  // Paginación
  paginacionRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  totalInfo: { color: '#555', fontSize: 12 },
  paginaBotones: { display: 'flex', gap: 4 },
  paginaBtn: { background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 6, color: '#aaa', padding: '6px 11px', cursor: 'pointer', fontSize: 13, minWidth: 34, textAlign: 'center' },
  paginaBtnActivo: { background: '#4cc9f0', border: '1px solid #4cc9f0', color: '#0f0f1a', fontWeight: 'bold' },
  // Tabla
  tabla: { background: '#1e1e2e', borderRadius: 12, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '12px 16px', borderBottom: '1px solid #2d2d44', gap: 8 },
  col: { color: '#888', fontSize: 12, fontWeight: 'bold', display: 'flex', alignItems: 'center' },
  tablaRow: { display: 'flex', padding: '14px 16px', borderBottom: '1px solid #1a1a2e', gap: 8, alignItems: 'center' },
  badge: { fontSize: 11, fontWeight: '600', padding: '3px 8px', borderRadius: 4 },
  badgeNuevo: { background: '#e63946', color: '#fff', fontSize: 9, fontWeight: 'bold', padding: '2px 6px', borderRadius: 4, marginLeft: 6 },
  botonRevalidar: { background: 'none', border: '1px solid #4cc9f0', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 14, color: '#4cc9f0' },
  botonImprimir: { background: '#1a1a2e', border: '1px solid #4cc9f0', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 14, color: '#4cc9f0' },
  botonVer: { background: '#1a1a2e', border: '1px solid #7c3aed', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 14, color: '#a78bfa' },
  botonCancelar: { background: 'none', border: '1px solid #555', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 13, color: '#888' },
  // Modal
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  modalContainer: { background: '#13131f', border: '1px solid #2d2d44', borderRadius: 16, width: '100%', maxWidth: 780, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 80px rgba(0,0,0,0.6)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #2d2d44', background: '#1a1a2e' },
  modalTitulo: { color: '#fff', fontWeight: 'bold', fontSize: 16 },
  modalBotonImprimir: { background: '#1a1a2e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '7px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 'bold' },
  modalBotonCerrar: { background: 'none', border: '1px solid #2d2d44', borderRadius: 8, color: '#888', padding: '7px 12px', cursor: 'pointer', fontSize: 16 },
  modalBody: { overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 16 },
  modalSeccion: { background: '#1e1e2e', borderRadius: 10, padding: 16 },
  modalGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 24px' },
  modalCampo: { display: 'flex', flexDirection: 'column', gap: 2 },
  modalLabel: { color: '#555', fontSize: 10, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1 },
  modalValor: { color: '#ddd', fontSize: 13 },
  modalAlertaKm: { background: '#0f1e3a', border: '1px solid #1a3a6e', borderRadius: 8, padding: '10px 14px', color: '#7eb8f7', fontSize: 13 },
  modalSeccionTitulo: { color: '#555', fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1, marginBottom: -8 },
  modalTabla: { background: '#1e1e2e', borderRadius: 10, overflow: 'hidden' },
  modalTablaHeader: { display: 'flex', padding: '10px 14px', background: '#1a1a2e', gap: 8 },
  modalTablaRow: { display: 'flex', padding: '10px 14px', borderBottom: '1px solid #13131f', gap: 8, alignItems: 'center' },
  modalTablaCol: { fontSize: 12, color: '#888', fontWeight: 'bold' },
  modalFirmas: { display: 'flex', justifyContent: 'space-around', marginTop: 8, paddingTop: 16 },
  modalFirma: { textAlign: 'center', width: '40%' },
  modalFirmaLinea: { borderTop: '1px solid #2d2d44', marginBottom: 8 },
  modalFirmaTxt: { color: '#555', fontSize: 11 },
  // Input factura manual
  inputFacturaRow: { background: '#1a2a3e', borderBottom: '1px solid #1a1a2e', padding: '12px 16px 14px', borderLeft: '3px solid #4cc9f0' },
  inputFacturaInner: { display: 'flex', alignItems: 'center', gap: 10 },
  inputFacturaLabel: { color: '#4cc9f0', fontSize: 12, fontWeight: 'bold', whiteSpace: 'nowrap' },
  inputFactura: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '7px 12px', fontSize: 13, width: 200, letterSpacing: 1 },
  botonConfirmar: { background: '#1a3a2a', border: '1px solid #4caf50', borderRadius: 6, color: '#4caf50', padding: '7px 16px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  inputFacturaError: { color: '#e63946', fontSize: 12, marginTop: 8, paddingLeft: 2 },
};